import { useQuery } from '@apollo/client';
import { useEffect, useRef, useState } from 'react';
import { debounce } from 'lodash';
import { ReportsQueryFilter } from '../../shared/types';
import { CITRIN_GET_REPORTS_COUNTERS, GetReportsRequest, GetReportsCountersResponse } from '..';

export const useGetReportsCountersQuery = (request?: ReportsQueryFilter, debounceTime?: number) => {
    const [internalRequest, setInternalRequest] = useState(() => request);
    const debounced = useRef(
        debounce(
            (newRequest: ReportsQueryFilter) => {
                setInternalRequest(newRequest);
            },
            debounceTime ?? 100,
            { leading: false, trailing: true }
        )
    ).current;
    useEffect(() => {
        return debounced(request);
    }, [request]);

    const { data, previousData, ...rest } = useQuery<GetReportsCountersResponse, GetReportsRequest>(
        CITRIN_GET_REPORTS_COUNTERS,
        {
            variables: { request: internalRequest },
            // fetchPolicy: 'cache-and-network',
            // onCompleted: (data) => console.log('[MGT] Users', data),
        }
    );

    return {
        ...rest,
        previousData: previousData?.CITRIN_MGT_getReportsCounters,
        data: data?.CITRIN_MGT_getReportsCounters ?? [],
    };
};
